/* eslint-disable react/prop-types, */
import React from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as userActions from '../../actions/userActions'
import * as commonActions from '../../actions/commonActions'

import '../../assets/styles/components/activity/ActivityFeedPage.scss'
import Activity from '../activity/Activity'

class ProfileActivities extends React.Component{
  constructor(props, context){
    super(props, context)

    this.showPostActivityMenu = this.showPostActivityMenu.bind(this)
  }

  showPostActivityMenu(e) {
    e.preventDefault()
    this.props.common_actions.showActivitySocialMenu(true)
  }

  displayActivities(){
    if (this.props.allActivities && this.props.allActivities.length > 0){
      return (
        this.props.allActivities.map(activity =>
          <Activity
            key={activity.id}
            displayComments={false}
            activity={activity}
          />
        )
      )
    } else {
      const { t } = this.props
      const postActivity = (this.props.current_user.id === this.props.user.id)
        ? (
          <p className='text-center'>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href='#' onClick={this.showPostActivityMenu} className='btn btn-sm btn-primary'> {t('profile.common.postAnActivity')}</a>
          </p>
        )
        : (<span></span>)
      const noActivitiesText = (this.props.current_user.id === this.props.user.id)
        ? (t('profile.activitiesWeb.noActivitiesSelf')) : (t('profile.activitiesWeb.noActivities', { firstName: this.props.user.first_name }))

      return (
        <div>
          <div className='sky'>
            <div className='empty-putt py-2'>
              <h4 className='text-center'>{noActivitiesText}</h4>
              {postActivity}
            </div>
          </div>
        </div>
      )
    }
  }

  render(){
    return (
      // eslint-disable-next-line react/no-string-refs
      <div id='profileActivities' ref='profileActivities' style={{ overflow: 'auto' }} onScroll={this.handleScroll}>
        {this.displayActivities()}
      </div>
    )
  }
}

function mapStateToProps(state, _ownProps){
  return {
    ui: state.ui,
    user: state.user.user,
    current_user: state.user.current_user,
  }
}

function mapDispatchToProps(dispatch){
  return {
    actions: bindActionCreators(userActions, dispatch),
    common_actions: bindActionCreators(commonActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ProfileActivities))
